import { render, staticRenderFns } from "./BusinessPublicPage.vue?vue&type=template&id=6fd5aa60&scoped=true&"
import script from "./BusinessPublicPage.vue?vue&type=script&lang=js&"
export * from "./BusinessPublicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5aa60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VFadeTransition,VSheet})
